// AUTO-GENERATED by tools/design-tokens/generate-css-refs.ts -- do not edit.
// Regenerate: npm run generate:derived-artifacts (or any typecheck/vitest run -- both ensure it)

/** Active/pressed interaction state tokens */
export const active = {
	scale: {
		subtle: "var(--interaction-active-scale-subtle)",
		medium: "var(--interaction-active-scale-medium)",
		strong: "var(--interaction-active-scale-strong)",
	},
	opacity: {
		medium: "var(--interaction-active-opacity-medium)",
		strong: "var(--interaction-active-opacity-strong)",
	},
	brightness: {
		darken: "var(--interaction-active-brightness-darken)",
		darker: "var(--interaction-active-brightness-darker)",
	},
	transform: "var(--interaction-active-transform)",
	transition: "var(--interaction-active-transition)",
} as const;

/** Disabled interaction state tokens */
export const disabled = {
	opacity: "var(--interaction-disabled-opacity)",
	cursor: "var(--interaction-disabled-cursor)",
	pointerEvents: "var(--interaction-disabled-pointer-events)",
} as const;
